import { splice } from './splice.ts';

/**
 * Returns a new array with valueToReplace replaced with newValue.
 * If valueToReplace is not present, newValue will be added to the end of the array.
 */
export function replaceValue<T>(arr: readonly T[], valueToReplace: T | undefined, newValue: T): T[] {
  const index = valueToReplace === undefined ? -1 : arr.indexOf(valueToReplace);

  if (index === -1) {
    return [...arr, newValue];
  }

  return splice(arr, index, 1, newValue);
}